import React, { useState } from 'react';

function Navbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);

  return (
    <>
      <header className="bg-[#2D2D2D] text-white py-4">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <img src="/ahorro/img/LOGO-GEEKFY-TRANSPARENTE-150X50.png" alt="Geekfy" className="h-12 brightness-0 invert" />
          <button className="md:hidden text-white text-2xl" onClick={() => setShowMobileMenu(!showMobileMenu)}>
            ☰
          </button>
          <nav className="hidden md:flex space-x-6">
            <a href="https://geekfy.es/empresa-telefonia-ip-valencia/" className="hover:text-[#E8C547] transition-colors">NOSOTROS</a>
            <a href="https://geekfy.es/ofertas-fibra-movil-valencia/" className="hover:text-[#E8C547] transition-colors">PARTICULARES</a>
            <div className="relative" onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() => setShowDropdown(false)}>
              <button className="hover:text-[#E8C547] transition-colors">GEEKFY EMPRESAS ▼</button>
              {showDropdown && (
                <div className="absolute top-full left-0 bg-[#2D2D2D] mt-2 py-2 w-48 rounded shadow-lg">
                  <a href="https://geekfy.es/telefonia-ip-valencia/" className="block px-4 py-2 hover:bg-[#E8C547] hover:text-black transition-colors">TELEFONÍA IP</a>
                  <a href="https://geekfy.es/centralita-virtual-valencia/" className="block px-4 py-2 hover:bg-[#E8C547] hover:text-black transition-colors">CENTRALITA VIRTUAL</a>
                  <a href="https://geekfy.es/fax-virtual-valencia/" className="block px-4 py-2 hover:bg-[#E8C547] hover:text-black transition-colors">FAX VIRTUAL</a>
                  <a href="https://geekfy.es/movil-y-fibra-optica-valencia/" className="block px-4 py-2 hover:bg-[#E8C547] hover:text-black transition-colors">MÓVIL Y FIBRA ÓPTICA</a>
                </div>
              )}
            </div>
            <a href="https://geekfy.es/tienda/" className="hover:text-[#E8C547] transition-colors">TIENDA</a>
            <a href="https://geekfy.es/contacto-empresa-telefonia-ip/" className="hover:text-[#E8C547] transition-colors">CONTACTO</a>
          </nav>
        </div>
      </header>

      {showMobileMenu && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowMobileMenu(false)}>
          <div className="fixed right-0 top-0 h-full w-64 bg-[#2D2D2D] text-white p-6 shadow-lg z-50" onClick={(e) => e.stopPropagation()}>
            <button className="text-2xl mb-8 float-right" onClick={() => setShowMobileMenu(false)}>✕</button>
            <nav className="flex flex-col space-y-4 clear-both pt-8">
              <a href="https://geekfy.es/empresa-telefonia-ip-valencia/" className="hover:text-[#E8C547] transition-colors">NOSOTROS</a>
              <a href="https://geekfy.es/ofertas-fibra-movil-valencia/" className="hover:text-[#E8C547] transition-colors">PARTICULARES</a>
              <div>
                <button onClick={() => setShowMobileDropdown(!showMobileDropdown)} className="hover:text-[#E8C547] transition-colors w-full text-left">
                  GEEKFY EMPRESAS {showMobileDropdown ? '▲' : '▼'}
                </button>
                {showMobileDropdown && (
                  <div className="pl-4 mt-2 space-y-2">
                    <a href="https://geekfy.es/telefonia-ip-valencia/" className="block hover:text-[#E8C547] transition-colors">TELEFONÍA IP</a>
                    <a href="https://geekfy.es/centralita-virtual-valencia/" className="block hover:text-[#E8C547] transition-colors">CENTRALITA VIRTUAL</a>
                    <a href="https://geekfy.es/fax-virtual-valencia/" className="block hover:text-[#E8C547] transition-colors">FAX VIRTUAL</a>
                    <a href="https://geekfy.es/movil-y-fibra-optica-valencia/" className="block hover:text-[#E8C547] transition-colors">MÓVIL Y FIBRA ÓPTICA</a>
                  </div>
                )}
              </div>
              <a href="https://geekfy.es/tienda/" className="hover:text-[#E8C547] transition-colors">TIENDA</a>
              <a href="https://geekfy.es/contacto-empresa-telefonia-ip/" className="hover:text-[#E8C547] transition-colors">CONTACTO</a>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
